import { calcPrice, DataLayer } from '@grandvisionhq/analytics';

function pushEvent(event, ecommerce) {
    DataLayer.pushEcommerceEvent({
        event,
        atfEcommerce: {
            ecommerce
        }
    });
}
function pushProductImpressions(product, position) {
    pushEvent('gvProductImpressions', {
        currencyCode: product.price.value.currencyCode,
        impressions: [
            convertProduct(product, position)
        ]
    });
}
function pushProductClick(product, position) {
    pushEvent('gvProductClick', {
        currencyCode: product.price.value.currencyCode,
        click: {
            actionField: {
                list: 'product recommendation mini cart'
            },
            products: [
                convertProduct(product, position)
            ]
        }
    });
}
function pushPromotionImpression(promotion) {
    pushEvent('gvPromotionImpressions', {
        promoView: {
            promotions: [
                convertPromotion(promotion)
            ]
        }
    });
}
function pushPromotionClick(promotion) {
    pushEvent('gvPromotionClick', {
        promoClick: {
            promotions: [
                convertPromotion(promotion)
            ]
        }
    });
}
function convertProduct(product, position) {
    return {
        name: product.name,
        id: product.sku,
        price: calcPrice(product.price.value.centAmount),
        brand: product.brand,
        list: 'product recommendation mini cart',
        position
    };
}
function convertPromotion(promotion) {
    return {
        name: promotion.title,
        creative: promotion.recommendationType,
        position: promotion.position
    };
}

export { pushEvent, pushProductClick, pushProductImpressions, pushPromotionClick, pushPromotionImpression };
//# sourceMappingURL=data-layer.js.map
